/**
 * The obligations the firm owes itself.
 *
 * Reading is staff-wide; signing one off is super_admin, because a completion
 * is an assertion — "I looked, and this is what I saw" — and it is worth only
 * as much as the accountability of whoever puts their name to it.
 *
 * There is deliberately no method to move a due date. A control you can
 * silently defer is not a control, so the only thing that moves it is a
 * recorded completion with a finding attached.
 */
import type { AxiosInstance } from 'axios';
import authService from './auth.service';

export interface OperationalReminder {
  id: string;
  reminder_key: string;
  title: string;
  instructions: string;
  why_it_matters: string;
  cadence_months: number;
  next_due_on: string;
  lead_days: number;
  is_active: boolean;
  /** Negative once overdue. */
  days_until_due: number;
  last_completed_at: string | null;
  last_completed_by: string | null;
  last_findings: string | null;
}

class RemindersService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async list(): Promise<OperationalReminder[]> {
    const res = await this.api.get<OperationalReminder[]>('/api/v1/ops/reminders');
    return res.data;
  }

  async complete(reminderKey: string, findings: string): Promise<void> {
    await this.api.post(`/api/v1/ops/reminders/${reminderKey}/complete`, { findings });
  }
}

export default new RemindersService();
